import * as PerformanceType from "../../types/admin/PerformanceType";

//Get All Performance
export const getAllPerformanceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.GET_ALL_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.GET_ALL_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.GET_ALL_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Create Performance
export const createPerformanceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.CREATE_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.CREATE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.CREATE_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Update Performance
export const updatePerformanceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.UPDATE_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.UPDATE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.UPDATE_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//Archive Performance
export const archivePerformanceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.ARCHIVE_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.ARCHIVE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.ARCHIVE_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

// Add Performance Comment
export const addPerformanceCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.ADD_PERFORMANCE_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.ADD_PERFORMANCE_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.ADD_PERFORMANCE_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};
//Update Performance
export const updatePerformanceCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.UPDATE_PERFORMANCE_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.UPDATE_PERFORMANCE_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.UPDATE_PERFORMANCE_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//getCommentForOnePerformance
export const getCommentForOnePerformanceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.GET_COMMENTS_FOR_ONE_PERFORMANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.GET_COMMENTS_FOR_ONE_PERFORMANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.GET_COMMENTS_FOR_ONE_PERFORMANCE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};

//deleteComment
export const deletePerformanceCommentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PerformanceType.DELETE_PERFORMANCE_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PerformanceType.DELETE_PERFORMANCE_COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case PerformanceType.DELETE_PERFORMANCE_COMMENT_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};
